module.exports = __webpack_public_path__ + "static/media/fly0178.bcd2f78d.webp";